(function () {
    'use strict';

    angular.module("imApp").factory("posComponentService", ['$ihttp', function ($ihttp) {
        let service = {
            getPos: function (parms) {
                return $ihttp.post({
                    method: 1922,
                    parameters: parms || {}
                });
            },
            listPoStatuses: function (parms) {
                return $ihttp.post({
                    method: 1348,
                    parameters: parms || {}
                });
            },
            setNewPoStatus: function (setting) {
                return $ihttp.post({
                    method: 3490,
                    parameters: setting
                });
            },
            deleteObj: function (setting) {
                return $ihttp.post({
                    method: 1926,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
